var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { transient, autoinject } from 'aurelia-dependency-injection';
import { BaseCart } from '../../base-cart';
import { BrandingBase } from '../../../../../views/app/admin/branding/branding-base';
import { Router } from 'aurelia-router';
import { DialogClientService } from '../../../../../services/basics/dialog-client.service';
import { I18N } from 'aurelia-i18n';
import { NotificationClientService } from '../../../../../services/basics/notification-client.service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { GamePlayerTicketClientService } from '../../../../../services/modules/client/client-game-player-ticket-client.service';
import { TokenClient } from '../../../../../services/authentication/token-client.service';
import { ClientLotteryClientService } from '../../../../../services/modules/client/client-lottery-client-service';
import { ClientHotLotteriesClientService } from '../../../../../services/modules/client/client-hot-lotteries-client.service';
import * as Enumerable from 'linq';
import { NavigationClientService } from '../../../../../services/modules/navigation-client.service';
var Cart = /** @class */ (function (_super) {
    __extends(Cart, _super);
    function Cart(router, gamePlayerTicketClientService, i18N, eventAggregator, dialogClientService, tokenClient, notificationClientService, lotteryClientService, hotLotteryClientService, navigationClientService) {
        return _super.call(this, router, gamePlayerTicketClientService, i18N, eventAggregator, dialogClientService, tokenClient, notificationClientService, lotteryClientService, hotLotteryClientService, navigationClientService) || this;
    }
    Cart.prototype.chooseNumbers = function (cartItem, line) {
        this.cartItemInEdit = cartItem;
        this.dialogLottery = Enumerable.from(this.lotteries).firstOrDefault(function (x) { return x.brandLotteryId == cartItem.brandLotteryId; });
        this.dialogKey = this.getLotteryKey(cartItem.lotteryName);
        this.isFirstTime = false;
        this.ticketInEdit = {
            bonus: line.bonus,
            main: line.main,
            guid: line.guid,
            ticketId: line.ticketId
        };
        this.hideClearfix = false;
        this.setChooseTicketHeight();
    };
    Cart.prototype.closeEditDialog = function () {
        var _this = this;
        this.ticketInEdit = null;
        this.sendHeightToClient(this.lastKnownHeight + "px", true);
        setTimeout(function () {
            _this.hideClearfix = true;
        }, 800);
    };
    Cart.prototype.termsAndConditions = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Images
                //Text
                //Colors
                "terms-and-conditions-foreground"
            ]
        }, window.parent.location.origin);
    };
    Cart.prototype.showCart = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Text
                "lotteries-cart-title",
                "lotteries-cart-column-label-item",
                "lotteries-cart-column-label-total",
                "lotteries-cart-subscribe",
                "lotteries-cart-account-balance",
                "lotteries-cart-sub-total",
                "lotteries-cart-sub-total-items-label",
                "lotteries-cart-total",
                "lotteries-cart-check-out",
                "lotteries-cart-fallback",
                "loading",
                "login-message",
                "insufficent-funds-error",
                "notification-error-title",
                "tickets-confirmed-notification-title",
                "tickets-confirmed-notification-message",
                //Colors
                "lotteries-cart-title-foreground",
                "lotteries-cart-title-border",
                "lotteries-cart-lottery-border",
                "lotteries-cart-lottery-background",
                "lotteries-cart-lottery-hover-background",
                "lotteries-cart-lottery-column-label-foreground",
                "lotteries-cart-lottery-name-foreground",
                "lotteries-cart-lottery-price-foreground",
                "lotteries-cart-lottery-info-foreground",
                "lotteries-cart-lottery-icon-remove-foreground",
                "lotteries-cart-lottery-icon-remove-hover-foreground",
                "lotteries-cart-lottery-icon-edit-foreground",
                "lotteries-cart-lottery-icon-edit-hover-foreground",
                "lotteries-cart-lottery-icon-edit-foreground",
                "lotteries-cart-lottery-subscribe-foreground",
                "lotteries-cart-lottery-icon-arrow-foreground",
                "lotteries-cart-sub-total-foreground",
                "lotteries-cart-sub-total-border",
                "lotteries-cart-total-box-border",
                "lotteries-cart-total-box-background",
                "lotteries-cart-total-box-foreground",
                "lotteries-cart-check-out-background",
                "lotteries-cart-check-out-hover-background",
                "lotteries-cart-check-out-foreground",
                "lotteries-cart-check-out-hover-foreground",
                "lotteries-cart-signin-foreground",
                "lotteries-cart-secured-payment-border",
                "lotteries-cart-secured-payment-foreground",
                "lotteries-cart-secured-payment-ssl-foreground",
                "lotteries-cart-lottery-number-background",
                "lotteries-cart-lottery-number-foreground",
                "lotteries-cart-lottery-number-bonus-background",
                "lotteries-cart-lottery-number-bonus-foreground",
                "lotteries-cart-lottery-login-message-background",
                "lotteries-cart-lottery-login-message-foreground"
            ]
        }, window.parent.location.origin);
    };
    Cart.prototype.showHottestLotteries = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Text
                "hottest-lotteries-title",
                "hottest-lotteries-remaning-time",
                "hottest-lotteries-remaning-days",
                "hottest-lotteries-remaning-hours",
                "hottest-lotteries-remaning-minutes",
                "hottest-lotteries-button",
                //Colors
                "hottest-lotteries-title-foreground",
                "hottest-lotteries-background",
                "hottest-lotteries-details-foreground",
                "hottest-lotteries-details-digits-background",
                "hottest-lotteries-details-digits-foreground",
                "hottest-lotteries-prize-currency-foreground",
                "hottest-lotteries-prize-amount-foreground",
                "hottest-lotteries-prize-button-background",
                "hottest-lotteries-prize-button-foreground"
            ]
        }, window.parent.location.origin);
    };
    Cart = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [Router, GamePlayerTicketClientService, I18N, EventAggregator,
            DialogClientService, TokenClient, NotificationClientService,
            ClientLotteryClientService, ClientHotLotteriesClientService, NavigationClientService])
    ], Cart);
    return Cart;
}(BaseCart));
export { Cart };
